import React from 'react';
export function DataQualityBadge({ quality, style }) {
  if (!quality) return null;
  const q = quality.toUpperCase();
  const cfg = {
    'FULL':      { label: 'Full Data',    color: '#10b981', bg: '#10b98122', icon: '✓' },
    'HIGH':      { label: 'Full Data',    color: '#10b981', bg: '#10b98122', icon: '✓' },
    'PARTIAL':   { label: 'Partial Data', color: '#eab308', bg: '#eab30822', icon: '◐' },
    'MEDIUM':    { label: 'Partial Data', color: '#eab308', bg: '#eab30822', icon: '◐' },
    'MINIMAL':   { label: 'Low Data',     color: '#ef4444', bg: '#ef444422', icon: '⚠' },
    'LOW':       { label: 'Low Data',     color: '#ef4444', bg: '#ef444422', icon: '⚠' },
    'GO_AROUND': { label: 'Go-Around',   color: '#065f46', bg: '#bbf7e0',   icon: '↥'  },
  }[q] || { label: q, color: '#888', bg: '#88888822', icon: '?' };
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: '0.65rem', fontWeight: 600,
      padding: '2px 8px', borderRadius: 10, color: cfg.color, background: cfg.bg, ...style }}>
      {cfg.icon} {cfg.label}
    </span>
  );
}
